import { render, staticRenderFns } from "./AddDocumentFooter.vue?vue&type=template&id=46fc20a6&scoped=true&"
import script from "./AddDocumentFooter.vue?vue&type=script&lang=js&"
export * from "./AddDocumentFooter.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentFooter.vue?vue&type=style&index=0&id=46fc20a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fc20a6",
  null
  
)

export default component.exports